import React from "react";

export default function DetailsReportButton({ isOpen, onClick }) {
  return (
    <button style={{ float: "right", fontWeight: "bold" }} onClick={onClick}>
      {isOpen ? "-" : "+"}
    </button>
  );
}
